import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

const ChargeTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.black};
`;

export default ChargeTitle;
